<template>
  <page-header-wrapper title="客服业绩统计">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col v-if="isSuperAdmin" :md="8" :sm="24">
              <a-form-item label="客服坐席">
                <a-select v-model="query.csAgentId" placeholder="全部" allow-clear style="width: 100%">
                  <a-select-option v-for="a in agents" :key="a.csAgentId" :value="a.csAgentId">
                    {{ a.nickName }} ({{ a.csAgentId.substring(0, 8) }}…)
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="24">
              <a-form-item label="时间范围">
                <a-range-picker v-model="dateRange" show-time style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-button type="primary" @click="loadAll"><a-icon type="search" />查询</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <a-row :gutter="16" style="margin-bottom: 24px">
        <a-col :span="4"><a-statistic title="代提总数" :value="summary.totalOrders || 0" /></a-col>
        <a-col :span="4"><a-statistic title="待审核" :value="summary.pendingOrders || 0" /></a-col>
        <a-col :span="4"><a-statistic title="已通过" :value="summary.completedOrders || 0" /></a-col>
        <a-col :span="4"><a-statistic title="已驳回" :value="summary.rejectedOrders || 0" /></a-col>
        <a-col :span="4"><a-statistic title="代提总额" :value="summary.totalCashAmount || 0" :precision="2" :group-separator="''" /></a-col>
        <a-col :span="4"><a-statistic title="已通过金额" :value="summary.completedCashAmount || 0" :precision="2" :group-separator="''" /></a-col>
      </a-row>

      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false">
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="orange">待审核</a-tag>
          <a-tag v-else-if="text === 2" color="green">已兑换</a-tag>
          <a-tag v-else color="red">驳回</a-tag>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        :current="query.pageNum"
        :total="total"
        :page-size="query.pageSize"
        @change="p => { query.pageNum = p; loadList() }"
        @showSizeChange="(_, s) => { query.pageSize = s; loadList() }"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { csOrderPage, csOrderSummary, csAgentList } from '@/api/customer-service/order'

export default {
  name: 'CsStats',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      summary: {},
      agents: [],
      dateRange: [],
      query: { csAgentId: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: '订单号', dataIndex: 'orderNo' },
        { title: '用户邮箱', dataIndex: 'userEmail' },
        { title: '面额', dataIndex: 'faceValue' },
        { title: '到账', dataIndex: 'cashAmount' },
        { title: '张数', dataIndex: 'quantity' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' } },
        { title: '客服', dataIndex: 'adminNickName' },
        { title: '提交时间', dataIndex: 'createTime' }
      ]
    }
  },
  computed: {
    isSuperAdmin() {
      const info = this.$store.getters.userInfo || {}
      return info.id === 1 || info.userId === 1
    }
  },
  created() {
    if (this.isSuperAdmin) {
      csAgentList().then(res => { this.agents = res.data || [] })
    }
    this.loadAll()
  },
  methods: {
    buildTimeParams() {
      const p = { ...this.query }
      if (this.dateRange && this.dateRange.length === 2) {
        p.startTime = this.dateRange[0].format('YYYY-MM-DD HH:mm:ss')
        p.endTime = this.dateRange[1].format('YYYY-MM-DD HH:mm:ss')
      }
      return p
    },
    loadAll() {
      csOrderSummary(this.buildTimeParams()).then(res => { this.summary = res.data || {} })
      this.loadList()
    },
    loadList() {
      this.loading = true
      csOrderPage(this.buildTimeParams()).then(res => {
        this.list = (res.data && res.data.records) || []
        this.total = (res.data && res.data.total) || 0
      }).finally(() => { this.loading = false })
    }
  }
}
</script>
